/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoRatingSmartTile implements angular.IDirective {
        restrict = "E";
        scope = {
            ratingMapFn: "=?",
            max: "=?",
            value: "=?",
            tileWidth: "=",
            getRatingTextFn: "=?",
            showRatingDescription: "=?"
        };

        template = `
        <div id="tile{{ $parent.$index }}" class='average-rating-container' layout="row">
            <ul class='rating foreground' class='readonly'>
                <li ng-repeat='star in filledStars' class='star filled'>
					<i class='fa fa-star' ng-class="{large: ratingTileWidth > 270, 'fa-star-whole': star.type === 'whole', 'fa-star-quarter': star.type === 'quarter', 'fa-star-half': star.type === 'half', 'fa-star-three-quarter': star.type === 'three-quarter'}"></i>
				</li>
			</ul>
            <ul class='rating background' class='readonly'>
                <li ng-repeat='star in emptyStars' class='star'>
					<i class='fa fa-star' ng-class="{large: ratingTileWidth > 270}"></i>
				</li>
			</ul>       
        </div>
	    <div ng-if="showRatingDescription" class="fiveStarRatingBlock_text" ng-class="{small: ratingTileWidth < 150}" translate="{{ratingString}}"></div>  
`;

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            if (scope.max == undefined) { scope.max = 5; }
            if (scope.showRatingDescription == undefined) {
                scope.showRatingDescription = false;
            }
            scope.ratingString = '';
            scope.ratingMapFn = scope.ratingMapFn || ((value) => value ? value: 0);

            function updateStars() {
                scope.emptyStars = [];
                scope.filledStars = [];
                
                // Calculate number of whole stars by rounding down the star rating
                let ratingWholeNumber = scope.ratingMapFn(scope.value) ? Math.floor(scope.ratingMapFn(scope.value)) : 0;
                for (var i = 0; i < ratingWholeNumber; i++) {
                    scope.filledStars.push({type: 'whole'});
                }
                // Get partial quarter star if any
                if (scope.ratingMapFn(scope.value) - ratingWholeNumber >= 0.75) {
                    scope.filledStars.push({ type: 'three-quarter' });
                } else if (scope.ratingMapFn(scope.value) - ratingWholeNumber >= 0.5) {
                    scope.filledStars.push({ type: 'half' });
                } else if (scope.ratingMapFn(scope.value) - ratingWholeNumber >= 0.25) {
                    scope.filledStars.push({ type: 'quarter' });
                }

                // Number of unfilled stars
                var partialStars = _.filter(scope.filledStars, function (item: any) { return item.type === 'three-quarter' || item.type === 'half' || item.type === 'quarter' }).length;
                for (var i = 0; i < (scope.max - ratingWholeNumber - partialStars); i++) {
                    scope.emptyStars.push({});
                }

                // Text display
                if (scope.getRatingTextFn) {
                    scope.ratingString = scope.getRatingTextFn(scope.value);
                }
            };

            function getRatingTileWidth() {
                let width = $(angular.element(`#tile${scope.$parent.$index}`).closest('.fiveStarRatingBlock')).width();
                scope.ratingTileWidth = width;
            }

            scope.$watch("value", function (newVal) {
                if (typeof newVal !== undefined) { updateStars(); }
            }, true);

            scope.$watch("tileWidth", function (newVal) {
                if (newVal) { getRatingTileWidth(); }
            }, true);

            updateStars();
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoRatingSmartTile();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoRatingSmartTile", MeevoRatingSmartTile.factory());
}